var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-row",
    [
      _c("q-panel", [
        _c("div", { staticClass: "containers with-diagram" }, [
          _c("div", {
            ref: "canvas",
            staticClass: "canvas",
            style: _vm.getStyle(),
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: "--",
            "close-on-click-modal": false,
            visible: _vm.dialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
          },
        },
        [
          _c("element-detail", {
            attrs: {
              fromStructure: _vm.currentActivityFromStructure,
              element: _vm.element,
            },
            model: {
              value: _vm.currentActivity,
              callback: function ($$v) {
                _vm.currentActivity = $$v
              },
              expression: "currentActivity",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("ببند")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }